import React from "react";
import { useI18n } from "@/i18n";

export default function LegalPage({ i18nRoot }) {
  const { t } = useI18n();
  const sections = t(`${i18nRoot}.sections`);
  const intro = t(`${i18nRoot}.intro`, null);
  return (
    <section className="py-16 md:py-24">
      <div className="mx-auto max-w-3xl px-5 sm:px-8">
        <div className="text-[11px] uppercase tracking-[0.2em] text-[color:var(--rv-muted)] mb-3">{t(`${i18nRoot}.updated`)}</div>
        <h1 className="font-serif text-4xl md:text-5xl leading-tight tracking-tight">{t(`${i18nRoot}.title`)}</h1>
        {intro && typeof intro === "string" && (
          <p className="mt-6 text-lg text-[color:var(--rv-ink)]/85 leading-relaxed">{intro}</p>
        )}
        <div className="mt-10 space-y-8">
          {Array.isArray(sections) && sections.map((s, i) => (
            <div key={i}>
              <h2 className="font-serif text-xl md:text-2xl text-[color:var(--rv-ink)]">{s.h}</h2>
              <p className="mt-3 text-[color:var(--rv-ink)]/80 leading-relaxed">{s.p}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
